var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsKakaoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.134277,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#F9E001"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.38477C13.05 9.38477 9 12.5348 9 16.4348C9 18.9348 10.65 21.1348 13.2 22.3848L12.35 25.5348C12.3 25.6348 12.35 25.7348 12.4 25.7848C12.45 25.8348 12.5 25.8848 12.6 25.8848C12.65 25.8848 12.7 25.8848 12.75 25.8348L16.4 23.3848C16.95 23.4848 17.5 23.4848 18 23.4848C22.95 23.4848 27 20.3348 27 16.4348C27 12.5348 22.95 9.38477 18 9.38477Z",
    fill: "#3C1D1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsKakaoCircle);
export default __webpack_public_path__ + "static/media/sns_kakao_circle.c6c2b5a2668d941db6788fbbc3059935.svg";
export { ForwardRef as ReactComponent };